// extracted by mini-css-extract-plugin
export default {"Avatar":"Avatar_Avatar__Zu0CG","Null":"Avatar_Null__iBjNT"};